import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../assets/images/Logo.png";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

const Opbill = () => {
  const { billInvoiceNo } = useParams();
  const [billingData, setBillingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     window.print();
  //   }, 500);

  //   // Optional: After print or cancel
  //   window.onafterprint = () => {
  //     // Option 1: Just stay on the page (no action needed)
  //     // Option 2: Automatically close the tab (only works if tab was opened via JS)
  //     window.close();
  //   };

  //   return () => {
  //     clearTimeout(timer);
  //     window.onafterprint = null;
  //   };
  // }, []);


   useEffect(() => {
    const delayInMilliseconds = 100 * 30; // 2000 seconds = 2,000,000 ms
    const timer = setTimeout(() => {
      window.print();
    }, delayInMilliseconds);

    // Optional: close the tab after print
    window.onafterprint = () => {
      window.close();
    };

    return () => {
      clearTimeout(timer);
      window.onafterprint = null;
    };
  }, []);


  // Back to billing function

  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/billing/out-billing");
  };

    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  useEffect(() => {
    if (billInvoiceNo) {
      fetchBillingData();
    }
  }, [billInvoiceNo]);

  const fetchBillingData = async () => {
    try {
      setLoading(true);
      console.log("Fetching for billInvoiceNo:", billInvoiceNo);

      const response = await axios.get(
        `${Apiurl}/billing_management?bill_invoice_no=${billInvoiceNo}`
      );

      console.log("API response:", response);

      // Adjust based on actual API response structure
      const data = response.data.data || response.data; // Handle nested or flat response
      const filteredData = Array.isArray(data)
        ? data.find((item) => item.bill_invoice_no === billInvoiceNo)
        : null;

      console.log("Filtered data:", filteredData);

      if (filteredData) {
        setBillingData(filteredData);
      } else {
        setError(`No billing data found for bill_invoice_no: ${billInvoiceNo}`);
      }
    } catch (error) {
      console.error("API error:", error);
      setError(`Failed to fetch billing data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const numberToWords = (num) => {
    if (isNaN(num)) return "Invalid amount";
    num = parseFloat(num).toFixed(2);
    const rupees = Math.floor(num);
    const paise = Math.round((num - rupees) * 100);

    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const convertLessThanOneThousand = (n) => {
      if (n === 0) return "";
      if (n < 20) return a[n];
      const digit = n % 10;
      if (n < 100) return b[Math.floor(n / 10)] + (digit ? " " + a[digit] : "");
      return (
        a[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " and " + convertLessThanOneThousand(n % 100) : "")
      );
    };

    const convert = (n) => {
      if (n === 0) return "Zero";
      let result = "";
      if (n >= 10000000) {
        result +=
          convertLessThanOneThousand(Math.floor(n / 10000000)) + " Crore ";
        n %= 10000000;
      }
      if (n >= 100000) {
        result += convertLessThanOneThousand(Math.floor(n / 100000)) + " Lakh ";
        n %= 100000;
      }
      if (n >= 1000) {
        result +=
          convertLessThanOneThousand(Math.floor(n / 1000)) + " Thousand ";
        n %= 1000;
      }
      if (n > 0) {
        result += convertLessThanOneThousand(n);
      }
      return result.trim();
    };

    let result = convert(rupees) + " Rupees";
    if (paise > 0) {
      result += " and " + convertLessThanOneThousand(paise) + " Paise";
    }
    return result + " Only";
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="text-danger">{error}</div>;
  }

  if (!billingData) {
    return <div>No billing data available.</div>;
  }

  const patient = billingData.patients_details?.[0] || {};
  const doctor = billingData.doctor_details?.[0] || {};

  const bill = {
    number: billingData.bill_invoice_no || "N/A",
    date: billingData.bill_date || "N/A",
    Bill_by: billingData.bill_by || "N/A",
    first_name: patient.first_name || "N/A",
    last_name: patient.last_name || "",
    mobile_no: patient.mobile_no || "N/A",
    age: patient.age || "N/A",
    gender: patient.gender || "N/A",
    address: patient.address || "N/A",
    patient_id: billingData.patient_id || "N/A",
    ref: patient.referred_by_name || "N/A",
    ref_num: patient.referred_by_mobile || "N/A",
    consultant: doctor.doctor_name || "N/A",
    speciality: doctor.speciality || "N/A",
    payment: billingData.payment_type || "N/A",
    billedBy: billingData.created_by || "N/A",
    billedTime: billingData.created_at || "N/A",
    items: Array.isArray(billingData.bill_list) ? billingData.bill_list : [],
  };

  const totalAmount = Number(billingData.total_amount || 0);
  const amountInWords = numberToWords(totalAmount);

  const formatMoney = (value) => {
    const amount = Number(value || 0);
    return Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
  };

  return (
    <>
      <div className="invoice-toolbar d-print-none">
        <button className="btn btn-outline-secondary btn-sm" onClick={handleBack}>
          ← Back to Out Billing
        </button>
      </div>

      <main className="invoice-page">
        <section className="invoice-sheet">
          <header className="invoice-header">
            <div className="invoice-logo-wrap">
              <img src={logo} alt="4Health Homeopathy" className="invoice-logo" />
            </div>

            <div className="invoice-clinic">
              <h1>4HEALTH HOMEOPATHY</h1>
              <p>
                Ground Floor, Sixer Complex, Saradha College Road, Salem - 636007.
              </p>
            </div>

            <div className="invoice-meta">
              <div className="invoice-meta-row">
                <span>Invoice No</span>
                <strong>{bill.number}</strong>
              </div>
              <div className="invoice-meta-row">
                <span>Bill Date</span>
                <strong>{bill.date}</strong>
              </div>
            </div>
          </header>

          <div className="invoice-title-row">
            <span className="invoice-title-line" />
            <h2>OUT PATIENT CASH BILL</h2>
            <span className="invoice-title-line" />
          </div>

          <section className="invoice-info-grid">
            <div className="invoice-info-card">
              <div className="invoice-info-row">
                <span>Patient ID</span>
                <strong>{bill.patient_id}</strong>
              </div>
              <div className="invoice-info-row">
                <span>Patient Name</span>
                <strong>
                  {bill.first_name}
                  {bill.last_name ? ` ${bill.last_name}` : ""}
                </strong>
              </div>
              <div className="invoice-info-row">
                <span>Mobile</span>
                <strong>{bill.mobile_no}</strong>
              </div>
            </div>

            <div className="invoice-info-card">
              <div className="invoice-info-row">
                <span>Age / Sex</span>
                <strong>
                  {bill.age} / {bill.gender}
                </strong>
              </div>
              <div className="invoice-info-row">
                <span>Consultant</span>
                <strong>{bill.consultant}</strong>
              </div>
              <div className="invoice-info-row">
                <span>Speciality</span>
                <strong>{bill.speciality}</strong>
              </div>
            </div>
          </section>

          <section className="invoice-items-section">
            <table className="invoice-items-table">
              <thead>
                <tr>
                  <th className="text-center" style={{ width: "54px" }}>
                    S.No
                  </th>
                  <th style={{ width: "28%" }}>Service Type</th>
                  <th>Description</th>
                  <th className="text-end" style={{ width: "120px" }}>
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {bill.items.length > 0 ? (
                  bill.items.map((item, index) => (
                    <tr key={item._id || index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{item.service_type || "N/A"}</td>
                      <td>{item.description || "N/A"}</td>
                      <td className="text-end">
                        ₹ {formatMoney(item.fees)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center text-muted py-3">
                      No billing items available
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={3} className="text-end">
                    Total Amount
                  </td>
                  <td className="text-end">
                    ₹ {formatMoney(totalAmount)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </section>

          <section className="invoice-words">
            <span>Amount in words</span>
            <strong>{amountInWords}</strong>
          </section>

          <footer className="invoice-footer">
            <div className="invoice-payment">
              <div>
                <span>Paid Date</span>
                <strong>{bill.date}</strong>
              </div>
              <div>
                <span>Payment Mode</span>
                <strong>{bill.payment}</strong>
              </div>
              <div>
                <span>Billed By</span>
                <strong>{bill.Bill_by}</strong>
              </div>
            </div>

            <div className="invoice-signature">
              <strong>For 4Health Homeopathy</strong>
              <span>Authorized Signature</span>
            </div>
          </footer>
          <div className="invoice-copyright">
  © Developed by Aalan Techsoft
</div>
        </section>
      </main>

      <style>{`
        :root {
          --invoice-brand: #01AEBE;
          --invoice-brand-soft: #eef7f8;
          --invoice-border: #dce4e6;
          --invoice-text: #243437;
          --invoice-muted: #66777a;
          --invoice-surface: #f8fafb;
        }

        .invoice-toolbar {
          max-width: 8.3in;
          margin: 12px auto 6px;
          padding: 0 8px;
        }

        .invoice-page {
          padding: 4px 12px 28px;
        }

        .invoice-sheet {
          width: 100%;
          max-width: 8.3in;
          margin: 0 auto;
          background: #fff;
          border: 1px solid var(--invoice-border);
          border-radius: 10px;
          box-shadow: 0 8px 24px rgba(24, 58, 63, 0.08);
          color: var(--invoice-text);
          font-family: Arial, Helvetica, sans-serif;
          font-size: 10.5px;
          line-height: 1.35;
          overflow: hidden;
        }

        .invoice-header {
          display: grid;
          grid-template-columns: 140px 1fr 190px;
          gap: 12px;
          align-items: center;
          padding: 14px 16px 12px;
          border-bottom: 1px solid var(--invoice-border);
        }

        .invoice-logo-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .invoice-logo {
          max-width: 130px;
          max-height: 100px;
          object-fit: contain;
        }

        .invoice-clinic {
          text-align: center;
        }

        .invoice-clinic h1 {
          margin: 0 0 4px;
          color: var(--invoice-brand);
          font-size: 16px;
          font-weight: 800;
          letter-spacing: 0.35px;
        }

        .invoice-clinic p {
          margin: 0;
          color: var(--invoice-muted);
          font-size: 10px;
          line-height: 1.45;
        }

        .invoice-meta {
          border: 1px solid var(--invoice-border);
          border-radius: 7px;
          overflow: hidden;
        }

        .invoice-meta-row {
          display: flex;
          flex-direction: column;
          gap: 2px;
          padding: 7px 9px;
        }

        .invoice-meta-row + .invoice-meta-row {
          border-top: 1px solid var(--invoice-border);
        }

        .invoice-meta-row span {
          color: var(--invoice-muted);
          font-size: 9px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        .invoice-meta-row strong {
          color: var(--invoice-text);
          font-size: 10.5px;
          overflow-wrap: anywhere;
        }

        .invoice-title-row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 16px 8px;
        }

        .invoice-title-row h2 {
          margin: 0;
          color: var(--invoice-brand);
          font-size: 11px;
          font-weight: 800;
          white-space: nowrap;
          letter-spacing: 0.65px;
        }

        .invoice-title-line {
          height: 1px;
          flex: 1;
          background: var(--invoice-border);
        }

        .invoice-info-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          padding: 0 16px 10px;
        }

        .invoice-info-card {
          padding: 8px 10px;
          background: var(--invoice-surface);
          border: 1px solid #e7edef;
          border-radius: 7px;
        }

        .invoice-info-row {
          display: grid;
          grid-template-columns: 86px 1fr;
          gap: 8px;
          align-items: start;
          min-height: 20px;
          padding: 2px 0;
        }

        .invoice-info-row span {
          color: var(--invoice-muted);
          font-weight: 600;
        }

        .invoice-info-row strong {
          color: var(--invoice-text);
          font-weight: 700;
          overflow-wrap: anywhere;
        }

        .invoice-items-section {
          padding: 0 16px;
          min-height: 180px;
        }

        .invoice-items-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          border: 1px solid var(--invoice-border);
          border-radius: 7px;
          overflow: hidden;
          margin: 0;
        }

        .invoice-items-table th,
        .invoice-items-table td {
          padding: 7px 8px;
          border-right: 1px solid #e8edef;
          border-bottom: 1px solid #e8edef;
          vertical-align: middle;
        }

        .invoice-items-table th:last-child,
        .invoice-items-table td:last-child {
          border-right: 0;
        }

        .invoice-items-table tbody tr:last-child td {
          border-bottom: 0;
        }

        .invoice-items-table thead th {
          background: var(--invoice-brand-soft);
          color: #31575c;
          font-weight: 800;
          font-size: 9.5px;
          text-transform: uppercase;
          letter-spacing: 0.25px;
        }

        .invoice-items-table tbody td {
          background: #fff;
          color: var(--invoice-text);
        }

        .invoice-items-table tbody tr:nth-child(even) td {
          background: #fbfcfc;
        }

        .invoice-items-table tfoot td {
          padding-top: 8px;
          padding-bottom: 8px;
          background: var(--invoice-brand-soft);
          color: var(--invoice-brand);
          font-weight: 800;
          border-bottom: 0;
        }

        .invoice-words {
          display: grid;
          grid-template-columns: 105px 1fr;
          gap: 8px;
          margin: 10px 16px 0;
          padding: 8px 10px;
          background: #fafcfc;
          border-radius: 4px;
        }

        .invoice-words span {
          color: var(--invoice-muted);
          font-weight: 600;
        }

        .invoice-words strong {
          font-weight: 700;
        }

        .invoice-footer {
          display: flex;
          justify-content: space-between;
          gap: 20px;
          align-items: flex-end;
          padding: 14px 16px 16px;
        }

        .invoice-payment {
          min-width: 240px;
        }

        .invoice-payment > div {
          display: grid;
          grid-template-columns: 90px 1fr;
          gap: 8px;
          padding: 2px 0;
        }

        .invoice-payment span {
          color: var(--invoice-muted);
          font-weight: 600;
        }

        .invoice-payment strong {
          font-weight: 700;
        }

        .invoice-signature {
          min-width: 170px;
          text-align: center;
        }

        .invoice-signature strong {
          display: block;
          color: var(--invoice-brand);
          margin-bottom: 26px;
        }

        .invoice-signature span {
          display: block;
          padding-top: 5px;
          border-top: 1px solid #9ca9ab;
          color: var(--invoice-muted);
        }

        @media (max-width: 700px) {
          .invoice-page {
            padding-left: 6px;
            padding-right: 6px;
          }

          .invoice-header {
            grid-template-columns: 70px 1fr;
          }

          .invoice-meta {
            grid-column: 1 / -1;
            display: grid;
            grid-template-columns: 1fr 1fr;
          }

          .invoice-meta-row + .invoice-meta-row {
            border-top: 0;
            border-left: 1px solid var(--invoice-border);
          }

          .invoice-info-grid {
            grid-template-columns: 1fr;
          }
        }

        @media print {
          @page {
            size: A5 portrait;
            margin: 5mm;
          }

          html,
          body {
            margin: 0 !important;
            padding: 0 !important;
            background: #fff !important;
          }

          .d-print-none,
          .invoice-toolbar {
            display: none !important;
          }

          .invoice-page {
            padding: 0 !important;
          }

          .invoice-sheet {
            max-width: none !important;
            width: 100% !important;
            border: 1px solid #cfd8da !important;
            border-radius: 0 !important;
            box-shadow: none !important;
            font-size: 9px !important;
            page-break-inside: avoid !important;
          }

          .invoice-header {
            grid-template-columns: 110px 1fr 160px !important;
            padding: 9px 10px 8px !important;
          }

          .invoice-logo {
            max-width: 100px !important;
            max-height: 78px !important;
          }

          .invoice-clinic h1 {
            font-size: 13px !important;
          }

          .invoice-clinic p,
          .invoice-meta-row strong {
            font-size: 8.5px !important;
          }

          .invoice-title-row {
            padding: 7px 10px 6px !important;
          }

          .invoice-info-grid {
            padding: 0 10px 7px !important;
            gap: 6px !important;
          }

          .invoice-info-card {
            padding: 5px 7px !important;
          }

          .invoice-info-row {
            min-height: 16px !important;
            grid-template-columns: 72px 1fr !important;
            padding: 1px 0 !important;
          }

          .invoice-items-section {
            padding: 0 10px !important;
            min-height: 145px !important;
          }

          .invoice-items-table th,
          .invoice-items-table td {
            padding: 4px 5px !important;
            font-size: 8.5px !important;
          }

          .invoice-words {
            margin: 7px 10px 0 !important;
            padding: 5px 7px !important;
            grid-template-columns: 88px 1fr !important;
          }

          .invoice-footer {
            padding: 9px 10px 10px !important;
          }

          .invoice-signature strong {
            margin-bottom: 18px !important;
          }

          .invoice-copyright {
  text-align: center;
  font-size: 8px;
  color: #8a989a;
  padding: 4px 10px 7px;
  border-top: 1px solid #eef1f2;
}
        }
      `}</style>
    </>
  );
};

export default Opbill;